import { render, staticRenderFns } from "./NotificationsForRoot.vue?vue&type=template&id=6bebac8a&"
import script from "./NotificationsForRoot.vue?vue&type=script&lang=ts&"
export * from "./NotificationsForRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports